import { PropsWithChildren } from "react";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { Params, Path } from "@/router";
import { LinkProps } from "@generouted/react-router/client";
import { getGrpNavLinks } from "./_utils";

type Props<P extends Path> = {
  navHeaderProps: {
    title: string;
    backLink: LinkProps<P, Params>;
  };
};

export default function GrpFormLayout<P extends Path>(props: PropsWithChildren<Props<P>>) {
  const { navHeaderProps, children } = props;
  const { title, backLink } = navHeaderProps;

  return (
    <AppLayout interior navLinks={getGrpNavLinks()}>
      <Breadcrumb title={title} backLink={backLink} />

      <div className="mt-16">
        <div className="px-6 py-6 xl:px-12 xl:py-8 rounded-2xl shadow-web-1 bg-sys-brand-surface">{children}</div>
      </div>
    </AppLayout>
  );
}
